/**
 * isiXhosa: Knowledge base
 *
 * What this file covers: The knowledge base the chatbot answers from: documents, websites, corrections,
 * conflicts and trying a question.
 *
 * Tone: Plain and patient. Explain what the chatbot will and will not know.
 *
 * isiXhosa: Everyday isiXhosa as used in South African business. Keys not translated yet fall back to English,
 * so a missing key is never an error.
 *
 * Rules for every translation: keep each key exactly as it is and translate only the text after it. Keep
 * {{placeholders}} such as {{count}} or {{name}} unchanged, and keep product names (RepletoryReach, WhatsApp,
 * Meta, Google, Outlook) as they are. Never use the em dash.
 */

import type { Catalog } from '../types';

const knowledge: Catalog = {
  'knowledge.add.hintMany': 'I-PDF, isicatshulwa, Markdown, HTML okanye CSV, ukuya kuthi ga kwi-20 MB nganye. Khetha ezininzi kanye: ifayile nganye ifakwa kumgca xa sele ilayishiwe, emva koko ihlelwe ngokulandelelana, kwaye ukuhlela kuyaqhubeka nokuba uyalishiya eli phepha.',
  'knowledge.add.queued': 'Kufakwe kumgca ukuze kuhlelwe: {{count}}',
  'knowledge.add.refusedTitle': 'Ezinye iifayile azongezwanga',
  'knowledge.add.refused.PLAN_LIMIT_REACHED': '{{name}}: isiseko solwazi secebo lakho sizele. Susa uxwebhu okanye utshintshe icebo ukuze wongeze ngaphezulu.',
  'knowledge.add.refused.ALREADY_ADDED': '{{name}}: sele ikho kwisiseko sakho solwazi.',
  'knowledge.add.refused.NO_TEXT': '{{name}}: akukho sicatshulwa sifundekayo sifunyenweyo. I-PDF eskeniweyo idinga ukuba isicatshulwa sayo sibonwe kuqala.',
  'knowledge.add.refused.MEDIA_NOT_FOUND': '{{name}}: ukulayisha akufumanekanga. Phinda uyilayishe.',
  'knowledge.add.refused.other': '{{name}}: {{message}}',
  'knowledge.add.sending': 'Kongezwa iifayile ezilayishiweyo…',
  'knowledge.list.status': 'Imeko',
  'knowledge.status.queued': 'Kumgca',
  'knowledge.status.indexing': 'Kuyahlelwa',
  'knowledge.status.indexed': 'Kuhlelwe',
  'knowledge.status.failed': 'Kusilele',
  'knowledge.list.retry': 'Zama i-{{name}} kwakhona',
  'knowledge.list.pending': 'Kuhlelwa amaxwebhu angama-{{count}}, elinye emva kwelinye. Ungalishiya eli phepha.',
  'knowledge.toast.retried': '"{{name}}" ibuyiselwe kumgca',
  'knowledge.toast.retryFailed': 'Ayikwazanga ukubuyisela uxwebhu kumgca',
  'knowledge.assistant.offerName': 'Nikezela ngomntu weqela',
  'knowledge.assistant.offer': 'Ungathanda ukuba ndidlulisele oku kumntu weqela lethu?',
  'knowledge.assistant.offerYes': 'Ewe',
  'knowledge.assistant.offerNo': 'Hayi',
  'knowledge.assistant.offerRetry': 'Nceda uphendule ngo-Ewe okanye Hayi.',
  'knowledge.assistant.declined': 'Akukho ngxaki. Ndibuze nantoni na enye nanini na.',
  'knowledge.assistant.intro': 'Abantu abalandeli ulandelelwano xa bekuthumelela umyalezo. Bayabuza. Vula oku kwaye i-bot iza kuphendula nawuphi na umyalezo ongathathwa lolunye ulandelelwano, isebenzisa lonke uxwebhu olapha. Xa ingaqinisekanga, iqala ngokubuza ukuba bangathanda uncedo lomntu weqela lakho, emva koko ibuze ukuba bafuna ntoni nendlela yokufikelela kubo, ize yazise iqela lakho.'
};

export default knowledge;
